export function pathOf(value, origin) {
  try { return new URL(value, origin).pathname.replace(/\/$/, '') || '/'; } catch { return ''; }
}

export function safeSource(value, origin, searchPath) {
  try {
    if (typeof value !== 'string' || value.length > 4096) return null;
    const url = new URL(value, origin);
    if (url.origin !== origin || url.username || url.password) return null;
    const path = pathOf(url.href, origin);
    const search = pathOf(searchPath, origin);
    if (path !== search && !/\/(collections|pages)\/[^/]+$/.test(path)) return null;
    url.searchParams.delete('sd_bc');
    return url;
  } catch { return null; }
}

export function searchLabel(url, data) {
  const term = (url.searchParams.get('q') || '').trim().slice(0,160);
  return term ? data.searchTemplate.replace('__TERMS__', term) : data.search;
}

export function sourceTrail(source, data, origin) {
  const url = safeSource(source.url, origin, data.searchUrl);
  if (!url) return null;
  const path = pathOf(url.href, origin);
  if (path === pathOf(data.searchUrl, origin)) return [{ label: searchLabel(url, data), url: url.pathname + url.search + url.hash }];
  const matched = data.paths.find(item => pathOf(item.url, origin) === path);
  const parents = matched ? matched.parents : [];
  const label = matched ? matched.label : String(source.label || '').trim().slice(0,180);
  if (!label) return null;
  const result = [...parents, {label, url:url.pathname + url.search + url.hash}];
  return result.filter((item,index) => result.findIndex(other => pathOf(other.url,origin) === pathOf(item.url,origin)) === index);
}

export function productPath(value, origin) {
  const path = pathOf(value, origin);
  const match = path.match(/\/(?:collections\/[^/]+\/)?products\/([^/]+)$/);
  return match ? '/products/' + match[1] : '';
}

export function decorateProductLink(href, source, origin, searchPath) {
  try {
    const url = new URL(href, origin);
    if (url.origin !== origin || !productPath(url.href,origin) || !safeSource(source.url,origin,searchPath)) return href;
    url.searchParams.set('sd_bc', JSON.stringify({url:source.url,label:source.label || ''}));
    return url.pathname + url.search + url.hash;
  } catch { return href; }
}

function start() {
  const dataNode = document.getElementById('sd-breadcrumb-data');
  if (!dataNode) return;
  let data;
  try { data = JSON.parse(dataNode.textContent); } catch { return; }
  const origin = location.origin;
  const nav = document.querySelector('[data-sd-breadcrumbs]');
  const key = 'sd.breadcrumb.pending.v1';

  function updateMobileReturn() {
    if (!nav) return;
    const links = nav.querySelectorAll('.sd-breadcrumbs__list a[href]');
    const parent = links[links.length - 1];
    if (!parent) return;
    const source = new URL(parent.href, origin);
    const label = pathOf(source.href, origin) === pathOf(data.searchUrl, origin)
      ? 'Back to search results'
      : 'Back to ' + parent.textContent.trim();
    let mobile = nav.querySelector('.sd-breadcrumbs__mobile');
    if (!mobile) {
      mobile = document.createElement('a');
      mobile.className = 'sd-breadcrumbs__mobile';
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '‹';
      const text = document.createElement('span');
      mobile.append(arrow, text);
      nav.append(mobile);
    }
    mobile.setAttribute('href', parent.getAttribute('href'));
    mobile.lastElementChild.textContent = label;
    nav.classList.add('sd-breadcrumbs--mobile-ready');
  }

  function draw(source) {
    if (!nav) return;
    const parts = sourceTrail(source,data,origin);
    if (!parts) return;
    const list = document.createElement('ol');
    list.className = 'sd-breadcrumbs__list';
    const trail = [{label:data.home,url:data.homeUrl},...parts,{label:data.title}];
    for (const [index,item] of trail.entries()) {
      const li = document.createElement('li');
      const text = document.createElement(index === trail.length - 1 ? 'span' : 'a');
      text.textContent = item.label;
      if (item.url) text.setAttribute('href',item.url);
      else text.setAttribute('aria-current','page');
      li.append(text);
      list.append(li);
    }
    nav.replaceChildren(list);
    updateMobileReturn();
  }

  function restore() {
    if (data.pageType !== 'product') return;
    const url = new URL(location.href);
    let context = null;
    try { context = JSON.parse(url.searchParams.get('sd_bc')); } catch {}
    if (!context) {
      const state = history.state;
      if (state && state.sdBreadcrumb && state.sdBreadcrumb.product === productPath(location.href,origin)) context = state.sdBreadcrumb.source;
    }
    if (!context) {
      try {
        const pending = JSON.parse(sessionStorage.getItem(key));
        const referrer = document.referrer && new URL(document.referrer);
        if (pending && Date.now() - pending.at < 30000 && pending.product === productPath(location.href,origin) && referrer && referrer.origin === origin && referrer.pathname === pending.from) context = pending.source;
      } catch {}
    }
    if (!context && document.referrer) {
      const referrer = safeSource(document.referrer,origin,data.searchUrl);
      if (referrer) {
        const entry = data.paths.find(item => pathOf(item.url,origin) === pathOf(referrer.href,origin));
        context = {url:referrer.pathname + referrer.search + referrer.hash,label:entry ? entry.label : ''};
      }
    }
    if (context && sourceTrail(context,data,origin)) {
      draw(context);
      try {
        const state = history.state && typeof history.state === 'object' ? history.state : {};
        url.searchParams.delete('sd_bc');
        history.replaceState({...state,sdBreadcrumb:{product:productPath(location.href,origin),source:context}},'',url.pathname + url.search + url.hash);
      } catch {}
    }
  }

  function sourceFor(element) {
    const popup = element.closest('#glFilter-search-popup, #SearchDrawer, predictive-search');
    if (popup) {
      const input = popup.querySelector('input[name="q"], input[type="search"], .gl-d-searchbox-input');
      const term = input && input.value.trim();
      if (term) {
        const url = new URL(data.searchUrl,origin);
        url.searchParams.set('q',term);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        return {url:url.pathname + url.search,label:searchLabel(url,data)};
      }
      return null;
    }
    const source = safeSource(location.href,origin,data.searchUrl);
    if (!source || !element.closest('main')) return null;
    return {url:source.pathname + source.search + source.hash,label:data.title};
  }

  function remember(event) {
    if ((event.button > 1 && event.type !== 'contextmenu') || event.defaultPrevented) return;
    const element = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!element) return;
    let link = element.closest('a[href]');
    if (!link) link = element.closest('[role="option"]')?.querySelector('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    let target;
    try { target = new URL(href,origin); } catch { return; }
    if (target.origin !== origin || !productPath(target.href,origin)) return;
    const source = sourceFor(link);
    if (!source) return;
    link.setAttribute('href',decorateProductLink(href,source,origin,data.searchUrl));
    try { sessionStorage.setItem(key,JSON.stringify({product:productPath(target.href,origin),source,from:location.pathname,at:Date.now()})); } catch {}
  }

  function updateSearch() {
    if (data.pageType !== 'search' || !nav) return;
    const current = nav.querySelector('[aria-current="page"]');
    if (current) current.textContent = searchLabel(new URL(location.href),data);
  }

  restore();
  updateMobileReturn();
  updateSearch();
  document.addEventListener('pointerdown',remember,true);
  document.addEventListener('click',remember,true);
  document.addEventListener('auxclick',remember,true);
  document.addEventListener('contextmenu',remember,true);
  window.addEventListener('pageshow',restore);
  window.addEventListener('popstate',updateSearch);
  window.addEventListener('globoFilterRenderSearchCompleted',updateSearch);
  window.addEventListener('globoFilterRenderCompleted',updateSearch);
}

if (typeof document !== 'undefined') start();
